import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../theme/colors";

export const SectionContainer = styled(Box)({
  marginBottom: "32px",
});

export const SectionHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "12px",
  "& button": {
    gap: "8px",
  },
});

export const SectionTitle = styled(Typography)({
  fontSize: "18px",
  fontWeight: 600,
  color: colors.text.primary,
  fontFamily: "Sora",
});

export const SectionContent = styled(Typography)({
  fontFamily: "Nunito",
  fontSize: "16px",
  color: colors.text.secondary,
  lineHeight: 1.6,
});
